import { Tag } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ActionButton } from '@/shared/ui/action-button';
import { Spinner } from '@/components/ui/spinner';

interface SubmitButtonProps {
  onClick: () => void;
  disabled: boolean;
  isSaving: boolean;
}

export function SubmitButton({ onClick, disabled, isSaving }: SubmitButtonProps) {
  const { t } = useTranslation();

  return (
    <ActionButton intent="primary" type="submit" onClick={onClick} disabled={disabled} className="h-10 px-8">
      {isSaving ? (
        <Spinner className="mr-2 h-4 w-4 border-white/30 border-t-white" />
      ) : (
        <Tag className="mr-2 h-4 w-4" />
      )}
      {t('newcmr.save.label')}
    </ActionButton>
  );
}
